import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import CaseStudyIslandResortMaldives2RevenueGrowth from "../pages/CaseStudyIslandResortMaldives2RevenueGrowth/CaseStudyIslandResortMaldives2RevenueGrowth";
import "../index.css";
import "../pages/CaseStudyIslandResortMaldives2RevenueGrowth/CaseStudyIslandResortMaldives2RevenueGrowth.module.css";

type AnyProps = Record<string, any>;

let root:
| ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;


        function App(props: AnyProps) {
        const { router = "memory", basename, initialEntries, ...pageProps } = props;

        if (router === "memory") {
        return (
        <MemoryRouter initialEntries={initialEntries ?? ["/"]}>
        <CaseStudyIslandResortMaldives2RevenueGrowth {...(pageProps as any)} />
        </MemoryRouter>
        );
        }

        return (
        <BrowserRouter basename={basename}>
            <CaseStudyIslandResortMaldives2RevenueGrowth {...(pageProps as any)} />
        </BrowserRouter>
        );
        }

        function mount(el: HTMLElement, props: AnyProps = {}) {
        console.log("Rendering......")
        root = createRoot(el);
        root.render(<App {...props} />);
        }

        function hydrate(el: HTMLElement, props: AnyProps = {}) {
        console.log("Hydrating......")

        root = hydrateRoot(el, <App {...props} />);
        }

        function unmount() {
        root?.unmount?.();
        root = null;
        }

        if (typeof window !== "undefined")
        (window as any).CaseStudyIslandResortMaldives2RevenueGrowthVC = { mount, hydrate, unmount };